
import List from 'vant/lib/list';
import { defineComponent, getCurrentInstance, ref, computed } from 'vue';

export default defineComponent({
    components: {
        vanList: List
    },
    props: {
        finished: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:loading', 'onLoad'],
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance() as { proxy: any };

        const loadingProps = computed({
            get: () => props.loading,
            set: (value: boolean) => {
                return emit('update:loading', value)
            }
        })

        const finishedText = computed(() => {
            return proxy.$root.$t('k_344289').replace('${0}', proxy.$appName)
        })

        const onLoad = () => {
            emit('onLoad')
        }

        return {
            proxy,
            loadingProps,
            finishedText,

            onLoad,
        };
  },
});
